import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { useHistory } from 'react-router-dom'

import RouteLink from '../route-link'

import NavigationButtonBase from '../navigation/navigation-button-base'

export const isActive = (
    history: ReturnType<typeof useHistory>,
    path: string,
    exact: boolean = false
) =>
    exact
        ? history.location.pathname === path
        : history.location.pathname.startsWith(path)

export const NavigationItem: React.FC<{
    to: string
    icon: React.ReactNode
    isActive: boolean
}> = React.memo(function NavigationItem(props) {
    return (
        <Box>
            <RouteLink to={props.to}>
                {props.children ? (
                    <Button
                        component={NavigationButtonBase}
                        isActive={props.isActive}
                        startIcon={props.icon}
                    >
                        {props.children}
                    </Button>
                ) : (
                    <IconButton
                        component={NavigationButtonBase}
                        isActive={props.isActive}
                    >
                        {props.icon}
                    </IconButton>
                )}
            </RouteLink>
        </Box>
    )
})
